import {css, Theme} from "@emotion/react";

import {borderRadius, mb, mt, p} from "@pg-design/helpers-css";
import {Loader} from "@pg-design/loader-module";
import {OFFER_TEST_IDS} from "@pg-mono/e2e-test-utils";

import {SubmitButton} from "./SubmitButton";

interface IProps {
    leadIsSubmitting: boolean;
    leadBtnText: string;
    onClick?: () => void;
}

export const ApplicationRevealButtonWithWrapper = (props: IProps) => {
    const {leadIsSubmitting, leadBtnText, onClick} = props;

    const submitButton = (
        <SubmitButton
            dataTestId={OFFER_TEST_IDS.LEAD_FORM.SEND_LEAD_BUTTON}
            css={[mt(2), mb(0)]}
            type="submit"
            variant="filled_primary"
            disabled={leadIsSubmitting}
            onClick={onClick}
        >
            {leadIsSubmitting ? <Loader /> : <>{leadBtnText}</>}
        </SubmitButton>
    );

    return <div css={revealPriceButtonWrapperStyle}>{submitButton}</div>;
};

const revealPriceButtonWrapperStyle = (theme: Theme) => css`
    ${mt(2)};
    ${p(0, 2, 2, 2)};
    display: flex;
    flex-direction: column;
    background-color: ${theme.colors.gray[300]};
    ${borderRadius(1)};
`;
import {css, Theme} from "@emotion/react";

import {borderRadius, mb, mt, p} from "@pg-design/helpers-css";
import {Loader} from "@pg-design/loader-module";
import {OFFER_TEST_IDS} from "@pg-mono/e2e-test-utils";

import {SubmitButton} from "./SubmitButton";

interface IProps {
    leadIsSubmitting: boolean;
    leadBtnText: string;
    onClick?: () => void;
}

export const ApplicationRevealButtonWithWrapper = (props: IProps) => {
    const {leadIsSubmitting, leadBtnText, onClick} = props;

    const submitButton = (
        <SubmitButton
            dataTestId={OFFER_TEST_IDS.LEAD_FORM.SEND_LEAD_BUTTON}
            css={[mt(2), mb(0)]}
            type="submit"
            variant="filled_primary"
            disabled={leadIsSubmitting}
            onClick={onClick}
        >
            {leadIsSubmitting ? <Loader /> : <>{leadBtnText}</>}
        </SubmitButton>
    );

    return <div css={revealPriceButtonWrapperStyle}>{submitButton}</div>;
};

const revealPriceButtonWrapperStyle = (theme: Theme) => css`
    ${mt(2)};
    ${p(0, 2, 2, 2)};
    display: flex;
    flex-direction: column;
    background-color: ${theme.colors.gray[300]};
    ${borderRadius(1)};
`;
